import createDOMPurify from 'dompurify';
import { JSDOM } from 'jsdom';

function getIsomorphicDomPurify() {
  const isServer = typeof window === 'undefined';
  if (isServer) {
    const window = new JSDOM('').window;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return createDOMPurify(window);
  }

  return createDOMPurify;
}

export function sanitize(content: string): string {
  const DOMPurify = getIsomorphicDomPurify();
  if (content) {
    return DOMPurify.sanitize(content);
  }

  return content;
}

export function sanitizeObject(
  content: Record<string, string>,
): Record<string, string> {
  if (!content) {
    return content;
  }

  return Object.fromEntries(
    Object.entries(content).map(([key, value]) => [key, sanitize(value)]),
  );
}
